import { render, staticRenderFns } from "./CommerceMap.vue?vue&type=template&id=1462c5bb&"
import script from "./CommerceMap.vue?vue&type=script&lang=js&"
export * from "./CommerceMap.vue?vue&type=script&lang=js&"
import style0 from "./CommerceMap.vue?vue&type=style&index=0&id=1462c5bb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports